import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { getEntryIcon, type Entry } from '@/types/index';
import { format, parseISO } from 'date-fns';
import { ja } from 'date-fns/locale';

interface EntryCardProps {
  entry: Entry;
}

export default function EntryCard({ entry }: EntryCardProps) {
  const icon = getEntryIcon(entry);
  const dateStr = entry.date || entry.created_at;
  const formattedDate = dateStr
    ? format(parseISO(dateStr), 'M月d日 (E)', { locale: ja })
    : '';

  return (
    <Link to={`/entry/${entry.id}`}>
      <Card className="hover:shadow-md transition-all hover:border-primary/30 cursor-pointer">
        <CardContent className="p-3 sm:p-4">
          <div className="flex items-start gap-2.5 sm:gap-3">
            {/* Mood emoji */}
            <div className="text-xl sm:text-2xl flex-shrink-0 mt-0.5">
              {icon}
            </div>

            <div className="flex-1 min-w-0">
              {/* Title + date */}
              <div className="flex items-center justify-between gap-2 mb-0.5">
                <h3 className="font-medium text-sm truncate">
                  {entry.title || 'エントリ'}
                </h3>
                <span className="text-[11px] sm:text-xs text-muted-foreground whitespace-nowrap shrink-0">
                  {formattedDate}
                </span>
              </div>

              {/* Content preview — モバイル: 2行、見切れない */}
              <p className="text-sm text-muted-foreground line-clamp-2 break-all">
                {(entry.summary || entry.content?.replace(/^---[\s\S]*?---\s*/, '').replace(/^#\s+.*\n+>\s+.*\n+##\s+Transcript\s*\n/, '').trim() || '').slice(0, 100)}
              </p>

              {/* Tags — モバイル: 最大3個 */}
              {entry.tags && entry.tags.length > 0 && (
                <div className="flex flex-wrap gap-1 mt-1.5">
                  {entry.tags.slice(0, typeof window !== 'undefined' && window.innerWidth < 640 ? 3 : 4).map(tag => (
                    <Badge key={tag} variant="secondary" className="text-[11px] sm:text-xs">
                      {tag}
                    </Badge>
                  ))}
                  {entry.tags.length > (typeof window !== 'undefined' && window.innerWidth < 640 ? 3 : 4) && (
                    <Badge variant="outline" className="text-[11px] sm:text-xs">
                      +{entry.tags.length - (typeof window !== 'undefined' && window.innerWidth < 640 ? 3 : 4)}
                    </Badge>
                  )}
                </div>
              )}
            </div>
          </div>
        </CardContent>
      </Card>
    </Link>
  );
}
